var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"blue-button",on:{"click":_vm.copyText}},[_vm._v("Text kopieren")])
}
var staticRenderFns = []

export { render, staticRenderFns }